import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Row, PdfButton, dl } from "./shared";

export default function NeracaPanel() {
  const [neraca, setNeraca] = useState(null);

  useEffect(() => {
    api.get("/reports/neraca").then((r) => setNeraca(r.data)).catch(() => {});
  }, []);

  return (
    <>
      <div className="flex items-center justify-between mt-4 mb-2">
        <h2 className="text-base font-bold tracking-tight">Neraca (per hari ini)</h2>
        <PdfButton testid="neraca-pdf-button" onClick={() => dl("/reports/neraca/pdf", "neraca.pdf")} />
      </div>
      {neraca && (
        <div className="rounded-md border border-border bg-white divide-y divide-border" data-testid="neraca-report">
          <p className="px-3.5 pt-3 text-[10px] uppercase tracking-[0.15em] font-bold text-muted-foreground">Aset</p>
          <Row label="Kas" value={neraca.kas} testid="neraca-kas" />
          <Row label="Bank" value={neraca.bank} testid="neraca-bank" />
          <Row label="Persediaan Barang" value={neraca.persediaan} testid="neraca-persediaan" />
          <Row label="Total Aset" value={neraca.total_aset} bold testid="neraca-total-aset" />
          <p className="px-3.5 pt-3 text-[10px] uppercase tracking-[0.15em] font-bold text-muted-foreground">Kewajiban & Ekuitas</p>
          <Row label="Hutang" value={neraca.hutang} testid="neraca-hutang" />
          <Row label="Modal" value={neraca.modal} testid="neraca-modal" />
          <Row label="Laba Ditahan" value={neraca.laba_ditahan} testid="neraca-laba" />
          <Row label="Total Pasiva" value={neraca.total_pasiva} bold testid="neraca-total-pasiva" />
        </div>
      )}
    </>
  );
}
